<template>
  <div>
    <div class="landing-cnt row">
      <div class="bg-heart"></div>
      <div class="bg-image"></div>
      <div class="col-12 d-landscape-none d-xl-none d-flex main-block-xs"></div>
      <!-- Main text block not logged -->
      <div class="text-block-ctn col-desktop-6 col-xl-6 col-landscape-6 col-12 d-flex my-auto">
        <div class="text-ctn my-0 my-lg-auto">
          <h1 v-html="$t('title-big-1')"></h1>
          <h3>{{ $t('title-small-1') }}</h3>
          <p>
            {{ $t('text-1')}}
          </p>
          <div class="btn-cnt">
            <base-button white shadow @click="() => { $router.push('/inicio-sesion') }">{{ $t('login-wrd') }}</base-button>
            <!-- <base-button blue shadow @click="() => { $router.push('/opensalud360/contacto') }">{{ $t('more-info') }}</base-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <neu-cards-slider class="section py-lg-5 py-0" :cards="cards" :title="$t('title-big-2')"></neu-cards-slider> -->

    <!-- <b-row id="how-does-it-work" class="section-invert reverse-sm">
        <b-col md="12" lg="6" class="content my-auto">
          <h3>{{ $t('title-big-3') }}</h3>
          <div class="subtitle">
            <div class="subtitle-list subtitle-list-large mt-sm-5 pt-sm-5">
              <div>
                <p>{{ $t('title-small-5') }}</p>
                <span>{{ $t('text-5') }}</span>
              </div>
              <div>
                <p>{{ $t('title-small-6') }}</p>
                <span>{{ $t('text-6') }}</span>
              </div>
              <div>
                <p>{{ $t('title-small-7') }}</p>
                <span>{{ $t('text-7') }}</span>
              </div>
              <div>
                <p>{{ $t('title-small-8') }}</p>
                <span>{{ $t('text-8') }}</span>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="12" lg="6">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>
      </b-row> -->

    <!-- <companies-contact-form class="py-lg-5" forIndividuals></companies-contact-form> -->
    <!-- <footer-360></footer-360> -->
  </div>
</template>

<script>
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import LangSelector from '@/components/base/LangSelector'
import NeuCardsSlider from '@/components/base/ui/NeuCardsSlider'
import { OPENSALUD_PRIME_SERVICE, FREEDOM_AND_FLOW_SERVICE, WELLWO_SERVICE, TELEMEDCARE_SERVICE } from '@/constants/patientServices'
import layoutMixin from '@/mixins/layout.mixin'

export default {
  mixins: [layoutMixin],
  name: 'landing-menu',
  components: {
    'sign-up': () => import('@/components/views/SignUp'),
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BNavItem,
    BCollapse,
    LangSelector,
    NeuCardsSlider
  },
  data () {
    return {
      OPENSALUD_PRIME_SERVICE,
      FREEDOM_AND_FLOW_SERVICE,
      WELLWO_SERVICE,
      TELEMEDCARE_SERVICE,
      hover: false,
      signInVisible: false,
      signUpVisible: false,
      cards: [
        {
          title: this.$t('title-small-2'),
          subtitle: this.$t('text-2'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_ICON_STAR.svg',
          titleLines: 1,
          subtitleLines: 2,
          type: 0
        },
        {
          title: this.$t('title-small-3'),
          subtitle: this.$t('text-3'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_ICON_PRICE.svg',
          titleLines: 1,
          type: 0
        },
        {
          title: this.$t('title-small-4'),
          subtitle: this.$t('text-4'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_ICON_LOCK.svg',
          type: 0
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "static-appopensalud/css/public/views/360.scss";
</style>


// WEBPACK FOOTER //
// src/components/views/360.vue